import { PersonaRequestBody } from './PersonaRequestBody';

/**
 * @public
 */
export type GetVariablesListRequestBody = PersonaRequestBody;
